itsoftApp.createModule("help", ["windowScroll"], function () {
    const module = this;

    const Help = function () {
        this.container = document.querySelector('.js-anim-help');
        this.video = this.container && this.container.querySelector('.js-anim-help-video');
        this.items = this.container && this.container.querySelectorAll('.js-anim-help-item');
        this.offsetTop = -100;
        this.play = false;

        if (this.container) {
            this.init();
        }
    }

    Help.prototype.init = function () {
        const THIS = this;

        THIS.onScroll();

        itsoftApp.modules.windowScroll.addEvent(THIS.onScroll.bind(THIS));

    }

    Help.prototype.onScroll = function () {
        const THIS = this;


        if (window.innerWidth > 767 && THIS.isBlockInWindow(THIS.container) && !THIS.play) {
            THIS.startAnim();
        }


    }

    Help.prototype.startAnim = function () {
        const THIS = this;

        THIS.play = true;
        THIS.video.play();
        let curIndex = 1;

        for (let index = THIS.items.length - 1; index >= 0; index--) {
            const element = THIS.items[index];
            const delay = index === THIS.items.length - 1 ? 300 : 300;

            setTimeout(() => {
                element.classList.add('_active');
            }, delay * curIndex);
            curIndex += 1;

        }
    }

    Help.prototype.isBlockInWindow = function (el) {
        const THIS = this;

        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = top - THIS.offsetTop;
        const pointBottom = bottom - THIS.offsetTop;

        return pointTop < itsoftApp.calculations.headerHeight && pointBottom > 0;
    }

    new Help();
    module.callback = Help;
});